<template>
  <v-icon :style="iconStyle" color="grey darken-1">
    {{ iconInfo.icon }}
  </v-icon>
</template>
<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  iconInfo: {
    icon: string
    color: string
    topPadding: number
    bottomPadding: number
    leftPadding: number
    rightPadding: number
  }
}>()

const iconStyle = computed(() => ({
  'padding-top': `${props.iconInfo.topPadding}px`,
  'padding-bottom': `${props.iconInfo.bottomPadding}px`,
  'padding-left': `${props.iconInfo.leftPadding}px`,
  'padding-right': `${props.iconInfo.rightPadding}px`,
}))
</script>
